import * as React from "react"
import styled from 'styled-components';
import { Container } from "react-bootstrap";

const StyledHeroContainer = styled(Container)`


`
const DropcontactAlternatives = () => {
    return (
        <StyledHeroContainer>
            <div>
                <h2 className="fw-bold py-3">Looking for a Dropcontact Alternative?</h2>
                <p>Let us help you decide why Clearout might be the best option for you over Dropcontact. Here's a detailed comparison between the two tools to assist you in making your decision.</p>
            </div>
        </StyledHeroContainer>
    )
}

export default DropcontactAlternatives;